import { render, staticRenderFns } from "./StepByStepV2.vue?vue&type=template&id=b3c04e10&lang=pug"
import script from "./StepByStepV2.vue?vue&type=script&lang=js"
export * from "./StepByStepV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports